import { Payment } from './payment';
import { Injectable } from "@angular/core";
import moment from 'moment-mini';

@Injectable()
export class PaymentSerializer {
  fromJson(json: any): Payment {
    const payment = {
      ...json,
      date: moment(json.date)
    }

    return payment
  }

  toJson(payment: Payment): any {
    return {
      ...payment,
      date: payment.date?.toISOString()
    }
  }
}
